import getParameterByName from '../utils/getParameterByName';

function heroVideo() {
  const $indexHero = document.querySelector('.js-index-hero');
  const $indexHeroVideo = document.querySelector('.js-index-hero-video');

  if (!$indexHero || !$indexHeroVideo) return;

  const controller = new ScrollMagic.Controller();

  const animation = new TimelineMax().fromTo(
    $indexHeroVideo,
    1,
    {
      scale: 1.2,
      autoAlpha: 1,
    },
    {
      scale: 1,
      autoAlpha: 0,
    }
  );

  const animationScene = new ScrollMagic.Scene({
    triggerElement: $indexHero,
    triggerHook: 'onLeave',
    duration: '50%',
    offset: '30%',
  })
    .setTween(animation)
    .addTo(controller);

  if (getParameterByName('animationDebug') == '1') {
    animationScene.addIndicators();
  }

  return animationScene;
}

function disciplineScroll() {
  const $disciplineItems = document.querySelectorAll('.js-discipline-item');

  if (!$disciplineItems.length) return [];

  const controller = new ScrollMagic.Controller();

  const scenes = [];

  $disciplineItems.forEach(($disciplineItem) => {
    const $img = $disciplineItem.querySelector('.js-discipline-item-img');

    const animation = new TimelineMax().fromTo(
      $img,
      1,
      {
        scale: 1.3,
      },
      {
        scale: 1,
      }
    );

    const animationScene = new ScrollMagic.Scene({
      triggerElement: $disciplineItem,
      triggerHook: 'onCenter',
      duration: '100%',
    })
      .setTween(animation)
      .addTo(controller);

    if (getParameterByName('animationDebug') == '1') {
      animationScene.addIndicators();
    }

    scenes.push(animationScene);
  });

  return scenes;
}

function organizersScroll() {
  const $organizers = document.querySelector('.js-organizers');
  const $organizersFigure = document.querySelector('.js-organizers-figure');

  if (!$organizers || !$organizersFigure) return [];

  const controller = new ScrollMagic.Controller();

  const scenes = [];

  const secondRowScene = new ScrollMagic.Scene({
    triggerElement: $organizers,
    triggerHook: 'onCenter',
    duration: $organizers.offsetHeight * 0.3333,
    offset: $organizers.offsetHeight * 0.3333,
  })
    .setClassToggle($organizersFigure, '--second')
    .addTo(controller);

  scenes.push(secondRowScene);

  if (getParameterByName('animationDebug') == '1') {
    secondRowScene.addIndicators({ colorTrigger: '#FF00C7' });
  }

  const thirdRowScene = new ScrollMagic.Scene({
    triggerElement: $organizers,
    triggerHook: 'onCenter',
    // duration: $organizers.offsetHeight * 0.3333,
    offset: $organizers.offsetHeight * 0.6666,
  })
    .setClassToggle($organizersFigure, '--third')
    .addTo(controller);

  scenes.push(thirdRowScene);

  if (getParameterByName('animationDebug') == '1') {
    thirdRowScene.addIndicators({ colorTrigger: '#FF00C7' });
  }

  const secondMobileRowScene = new ScrollMagic.Scene({
    triggerElement: $organizers,
    triggerHook: 'onCenter',
    // duration: $organizers.offsetHeight * 0.3333,
    offset: $organizers.offsetHeight * 0.25,
  })
    .setClassToggle($organizersFigure, '--second-mobile')
    .addTo(controller);

  scenes.push(secondMobileRowScene);

  if (getParameterByName('animationDebug') == '1') {
    thirdRowScene.addIndicators({ colorTrigger: '#FF00C7' });
  }

  const thirdMobileRowScene = new ScrollMagic.Scene({
    triggerElement: $organizers,
    triggerHook: 'onCenter',
    // duration: $organizers.offsetHeight * 0.3333,
    offset: $organizers.offsetHeight * 0.5,
  })
    .setClassToggle($organizersFigure, '--third-mobile')
    .addTo(controller);

  scenes.push(thirdMobileRowScene);

  if (getParameterByName('animationDebug') == '1') {
    thirdRowScene.addIndicators({ colorTrigger: '#FF00C7' });
  }

  const fourthMobileRowScene = new ScrollMagic.Scene({
    triggerElement: $organizers,
    triggerHook: 'onCenter',
    // duration: $organizers.offsetHeight * 0.3333,
    offset: $organizers.offsetHeight * 0.75,
  })
    .setClassToggle($organizersFigure, '--fourth-mobile')
    .addTo(controller);

  scenes.push(fourthMobileRowScene);

  if (getParameterByName('animationDebug') == '1') {
    thirdRowScene.addIndicators({ colorTrigger: '#FF00C7' });
  }

  return scenes;
}

export default function () {
  const heroVideoScene = heroVideo();
  const disciplineScrollScenes = disciplineScroll();
  const organizersScenes = organizersScroll();

  const scenes = [];

  if (heroVideoScene) scenes.push(heroVideoScene);
  disciplineScrollScenes.forEach((scene) => {scenes.push(scene)});
  organizersScenes.forEach((scene) => {scenes.push(scene)});

  if (!scenes.length) return;

  window.updateScenes = () => {
    scenes.forEach((scene) => {
      scene.update(true);
      scene.refresh();
    });
  };

  let resizeTimer = null;

  $(window).on('resize', () => {
    clearTimeout(resizeTimer);

    resizeTimer = setTimeout(() => {
      window.updateScenes();
    }, 250);
  });
}



// WEBPACK FOOTER //
// ./assets/scripts/components/indexAnimations.js